import { useState } from "react";
import { Box } from "@mui/material";
import styles from "./index.module.css";
import { formatToIndianRupees } from "../../../utils/formatToIndianRupees";
import Button from "@mui/material/Button";
import downloadImg from "../../../assets/images/download.png";
import DeliveryOrder from "../DeliveryOrder/DeliveryOrder";
import axiosInstance from "../../../helpers/axios";
import CircularProgress from "@mui/material/CircularProgress";
import EditVlDetails from "./EditVlDetails.jsx";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { useSelector } from 'react-redux';
export default function LoanDetails({ profileDetails, shouldFetchData = true }) {
  // ;
  const { status } = useSelector(state => state.appContext);
  const [loading, setLoading] = useState(false);
  const [openPdf, setOpenPdf] = useState(false);
  const [doUrl, setDoUrl] = useState();
  const [openEditDetails, setOpenEditDetials] = useState(false)
  const decode = useCurrentUser();
  const user = null;

  const generateDeliveryOrder = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(
        `/vehicle-loan/generate-delivery-order`,
        {
          applicationId: profileDetails?.applicationId,
          userId: profileDetails?.userId,
        }
      );
      showUrlContent(res?.data?.data);
    } catch (error) {
      alert("Failed to generate DO. Please try again.");
    } 
  };

  const showUrlContent = async (s3Url) => {
    const filePath = s3Url?.split("com/")?.pop();
    try {
      const res = await axiosInstance.get(
        `/file/url-content?path=${filePath}`,
        {
          headers: {
          },
        }
      );
      setDoUrl(res?.data?.data);
      setOpenPdf(true);
    } catch (error) {
      alert("Failed to generate DO content. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.detailsContainer}>
      <Box sx={{gap:3}}>
        <Box>
          <span className={styles.fieldTitle}>Loan Amount: </span>
          <span className={styles.details}>
            {formatToIndianRupees(profileDetails?.courseFees)}
          </span>
        </Box>
        {profileDetails?.vehicleBrandName && (
          <Box>
            <span className={styles.fieldTitle}>Brand Name: </span>
            <span className={styles.details}>
              {profileDetails?.vehicleBrandName}
            </span>
          </Box>
        )}
        {profileDetails?.vehicleModel && (
          <Box>
            <span className={styles.fieldTitle}>Model: </span>
            <span className={styles.details}>
              {profileDetails?.vehicleModel}
            </span>
          </Box>
        )}
        {profileDetails?.propertyType && (
          <Box>
            <span className={styles.fieldTitle}>Property Type: </span>
            <span className={styles.details}>
              {profileDetails?.propertyType}
            </span>
          </Box>
        )}
        {profileDetails?.propertyAddress && (
          <Box>
            <span className={styles.fieldTitle}>Property Address: </span>
            <span className={styles.details}>
              {profileDetails?.propertyAddress}
            </span>
          </Box>
        )}
        {profileDetails?.propertySize && (
          <Box>
            <span className={styles.fieldTitle}>Property Size: </span>
            <span className={styles.details}>
              {profileDetails?.propertySize}
            </span>
          </Box>
        )}
        {profileDetails?.propertyDescription && (
          <Box>
            <span className={styles.fieldTitle}>Property Description: </span>
            <span className={styles.details}>
              {profileDetails?.propertyDescription}
            </span>
          </Box>
        )}
        {profileDetails?.subProductType && (
          <Box>
            <span className={styles.fieldTitle}>Product Type: </span>
            <span className={styles.details}>
              {profileDetails?.subProductType}
            </span>
          </Box>
        )}

        {profileDetails?.securitiesType && (
          <Box>
            <span className={styles.fieldTitle}>Security Type: </span>
            <span className={styles.details}>
              {profileDetails?.securitiesType}
            </span>
          </Box>
        )}
        {profileDetails?.securitiesIdNumber && (
          <Box>
            <span className={styles.fieldTitle}>Security ID / Reference No.: </span>
            <span className={styles.details}>
              {profileDetails?.securitiesIdNumber}
            </span>
          </Box>
        )}
        {profileDetails?.securitiesAmount && (
          <Box>
            <span className={styles.fieldTitle}>Security Amount: </span>
            <span className={styles.details}>
              {formatToIndianRupees(profileDetails?.securitiesAmount)}
            </span>
          </Box>
        )}
        {profileDetails?.otherDetails && (
          <Box>
            <span className={styles.fieldTitle}>Other Remarks: </span>
            <span className={styles.details}>
              {profileDetails?.otherDetails}
            </span>
          </Box>
        )}
      </Box>

      {profileDetails?.instituteName === "Vehicle Loan" && decode?.role==='admin' &&
        (status === "In Sanction" ||  status === "Ready To Disburse"  ||  status === "Disbursed" ) &&  (
          <Box>
            <Button
              sx={{
                border: "1px solid #fc9739ff",
                textTransform: "none",
                fontFamily:'Outfit'
              }}
              variant="outlined"
              onClick={() => setOpenEditDetials(true)}
            >
              Edit Details
            </Button>
            <Button
              className={styles.doButton}
              onClick={generateDeliveryOrder}
              endIcon={<img src={downloadImg} className={styles.doImg} />}
              disabled={loading}
              sx={{ml:1}}
            >
            {loading ? <CircularProgress size={18} style={{color:'#fff'}}/> : "Generate DO"}
            </Button>
            <DeliveryOrder
              openPdf={openPdf}
              setOpenPdf={setOpenPdf}
              doUrl={doUrl}
            />
            <EditVlDetails setOpenEditDetails ={setOpenEditDetials} openEditDetails={openEditDetails} applicationId={profileDetails?.applicationId}/>
          </Box>
        )}
    </div>
  );
}
